import type { CartAddressData } from 'services';

/** Resolves the secondary street line from saved street or company data. */
export function getStreetAddOn(address: CartAddressData, company: boolean, pickupPoint: boolean): string {
  if (address.streetAddOn) {
    return address.streetAddOn;
  }

  if (!company && !pickupPoint) {
    return address.company ?? '';
  }

  return '';
}